export default __webpack_public_path__ + "static/media/WalkinOff.a5b6ec07.svg";